import React, { useEffect } from "react";
import { Descriptions, Radio, Button } from "antd";
import dayjs from 'dayjs';

const DetailedScheduleAssignment = (props) => {

  let showAssignCommentLabel = () => {
    if(props.securityLevels.myAssignmentComment==1) {
      return false;
    }
    return true;
  }

  let showAssignCommentOption = () =>{
     return props.securityLevels.myAssignmentComment == 3;
  }


  const canEdit = props.canEdit //&& showEditBySameResource();
  const hasAssignments = (props.detailedSchedule.serviceOrders && props.detailedSchedule.serviceOrders.length > 0) ? true : false
  const showAssignHours = props.securityLevels.updateAssignmentHours  == 3   
  const showAssignComments = showAssignCommentOption()
  const showAssignCommentsLabel = showAssignCommentLabel()
  const showEditButton = canEdit && (showAssignHours || showAssignComments)
  
  useEffect(() => {
    let newEditType = ''
    showAssignHours ? newEditType = 'assignTimes' : showAssignComments ? newEditType = 'myAssignComment' : ''
    props.handleAssignmentRadio(newEditType)
  }, [showAssignComments])

  return (
    <React.Fragment>
      {hasAssignments && props.detailedSchedule.serviceOrders.map((schedule, index) => (

        <div key= {`detail-assignment-${index}`}>
          {
            showEditButton && schedule.approved == 0 &&
            <div>
              <Radio.Group onChange={(e) => {
                props.handleAssignmentRadio(e.target.value);
              }} value={props.editAssignType}>
                <React.Fragment>
                  {(props.securityLevels.updateAssignmentHours  == 3 && schedule.approved == 0) && <Radio value="assignTimes">Edit Assignment Times</Radio>}
                  {(showAssignComments && showAssignCommentsLabel) && <Radio value="myAssignComment">My Assignment Comment</Radio>}
                </React.Fragment>
              </Radio.Group>
              <Button type="primary"
              onClick={() => {
                if(schedule.allowChangeHours ==1){
                  props.openAssignModal(index);
                }
                else {
                  alert('The time zone in the tour and assignment does not match; please make this change in STORM Desktop.');
                }
              }}>Edit Assignment</Button>
            </div>
          }
          <Descriptions 
          title={'Assignment - ' + (dayjs.unix(props.detailedSchedule.serviceOrders[0].startDate).add(props.offset, 'minute').format('MM/DD/YYYY')) || ""} 
          style={{ marginBottom: 30 }} 
          bordered>
            <Descriptions.Item label="Start Date" span={3} >
              {dayjs.unix(props.detailedSchedule.serviceOrders[index].startDate).add(props.offset, 'minute').format('dddd, MMMM Do YYYY') || ""}
            </Descriptions.Item>
            <Descriptions.Item label="End Date" span={3}>
              {dayjs.unix(props.detailedSchedule.serviceOrders[index].startDate).add(props.offset, 'minute').format('dddd, MMMM Do YYYY') || ""}
            </Descriptions.Item>
            <Descriptions.Item label="Start Time" span={3}>
              {props.detailedSchedule.serviceOrders[index].startTimeH || "" }
            </Descriptions.Item>
            <Descriptions.Item label="End Time" span={3}>
             {props.detailedSchedule.serviceOrders[index].endTimeH || "" }
            </Descriptions.Item>
            <Descriptions.Item label="Service" span={3}>
              {props.detailedSchedule.serviceOrders[index].serviceName || ""}
            </Descriptions.Item>
            {(props.securityLevels.myScheduleAssignmentCostObject == 2) &&<Descriptions.Item label="Cost Object" span={3} >{props.detailedSchedule.serviceOrders[index].costObject || ''}</Descriptions.Item>}
            <Descriptions.Item label="Scheduler Comment" span={3}>
              {props.detailedSchedule.serviceOrders[index].schedulerComment && props.detailedSchedule.serviceOrders[index].schedulerComment !== "" ?
                props.detailedSchedule.serviceOrders[index].schedulerComment : ""
              }
            </Descriptions.Item>
            <Descriptions.Item label="Assignment Description Comment" span={3} class='label-wrap' >
              {props.detailedSchedule.serviceOrders[index].comment && props.detailedSchedule.serviceOrders[index].comment !== "" ?
                props.detailedSchedule.serviceOrders[index].comment : ""
              }
            </Descriptions.Item>
            {showAssignCommentsLabel && <Descriptions.Item label="My Assignment Comment" span={3} class='label-wrap' >
              {props.detailedSchedule.serviceOrders[index].employeeComment && props.detailedSchedule.serviceOrders[index].employeeComment !== "" ?
                props.detailedSchedule.serviceOrders[index].employeeComment : ""
              }
            </Descriptions.Item>}
            <Descriptions.Item label="Status" span={3} class='label-wrap' >
              {props.detailedSchedule.serviceOrders[index].status && props.detailedSchedule.serviceOrders[index].status !== "" ?
                props.detailedSchedule.serviceOrders[index].status : ""
              }
            </Descriptions.Item>
          </Descriptions>
        </div>
      ))}
    </React.Fragment>
  )
}

export default DetailedScheduleAssignment;
